import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={styles.footer}>
      <div className="footer_container" style={styles.footerContainer}>
        {/* Left column - Contact Info */}
        <div className="column_f" style={styles.columnF}>
          <h3 style={styles.columnTitle}>Contact Us</h3>
          <div style={styles.iconList}>
            <div style={styles.contactItem}>
              <span style={styles.icon}>📍</span>
              <span>
                123 Innovation Park,
                <br />
                Tech City, 560001
              </span>
            </div>
            <div style={styles.contactItem}>
              <span style={styles.icon}>📧</span>
              <a href="mailto:info@example.com" style={styles.link}>
                info@example.com
              </a>
            </div>
            <div style={styles.contactItem}>
              <span style={styles.icon}>📞</span>
              <a href="tel:+911234567890" style={styles.link}>
                +91 12345 67890
              </a>
            </div>
          </div>
        </div>

        {/* Middle column - Logo and description */}
        <div className="column_f fb_l" style={styles.columnFbL}>
          <div className="footer_logo" style={styles.footerLogo}>
            <img
              src={require("../../assets/logo.png")}
              alt="Company Logo"
              style={styles.logoImg}
            />
          </div>
          <p style={styles.description}>
            Building reliable, scalable, and user‑centric digital solutions that
            empower businesses to grow and innovate.
          </p>
          {/* <ul className="footer_icon_list" style={styles.footerIconList}>
            <li>
              <a
                href="#"
                aria-label="Facebook"
                style={styles.socialLink}
              >
                <span>🔵</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                aria-label="Twitter"
                style={styles.socialLink}
              >
                <span>🐦</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                aria-label="Instagram"
                style={styles.socialLink}
              >
                <span>📸</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                aria-label="LinkedIn"
                style={styles.socialLink}
              >
                <span>💼</span>
              </a>
            </li>
          </ul> */}
        </div>

        {/* Right column - Quick links */}
        <div className="column_f" style={styles.columnF}>
          <h3 style={styles.columnTitle}>Quick Links</h3>
          <div style={styles.linkList} className="link-list">
            <a href="#about" style={styles.link}>
              About Us
            </a>
            <a href="#services" style={styles.link}>
              Services
            </a>
            <a href="#careers" style={styles.link}>
              Careers
            </a>
            <a href="#contact" style={styles.link}>
              Contact
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={styles.copyright}>
        <p style={styles.copyrightText}>
          © {currentYear} Example Company. All rights reserved.
        </p>
        <ul style={styles.footerSlnks}>
          <li>
            <a href="#privacy" style={styles.legalLink}>
              Privacy Policy
            </a>
          </li>
          <li>
            <a href="#terms" style={styles.legalLink}>
              Terms of Service
            </a>
          </li>
          <li>
            <a href="#cookies" style={styles.legalLink}>
              Cookie Policy
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: '#191c41',
    color: '#e5e7eb',
    padding: '4rem 0 0',
    marginTop: 'auto',
    fontFamily: "'Oswald', sans-serif",
  },

  footerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '2rem',
    padding: '0 1rem 3rem',
    maxWidth: '1200px',
    margin: '0 auto',
    flexWrap: 'wrap',
  },

  columnF: {
    width: '29%',
    minWidth: '250px',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  columnFbL: {
    width: '42%',
    minWidth: '300px',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    alignItems: 'center',
    textAlign: 'center',
  },

  columnTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#ffffff',
    marginBottom: '0.5rem',
    fontFamily: "'Oswald', sans-serif",
  },

  footerLogo: {
    marginBottom: '1rem',
  },

  logoImg: {
    maxWidth: '100px',
    height: 'auto',
    objectFit: 'contain',
  },

  description: {
    fontSize: '0.925rem',
    lineHeight: '1.6',
    color: '#9ca3af',
    maxWidth: '100%',
    margin: '0 0 1rem',
  },

  iconList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },

  contactItem: {
    display: 'flex',
    alignItems: 'start',
    gap: '0.5rem',
    color: '#9ca3af',
    fontSize: '0.925rem',
  },

  icon: {
    color: '#291e6c',
    marginTop: '3px',
  },

  linkList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.625rem',
  },

  link: {
    color: '#9ca3af',
    textDecoration: 'none',
    fontSize: '0.925rem',
    transition: 'all 0.3s ease',
    width: 'fit-content',
  },

  footerIconList: {
    display: 'flex',
    listStyle: 'none',
    paddingLeft: 0,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '45px',
    marginBottom: 0,
  },

  socialLink: {
    color: '#9ca3af',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.35rem',
  },

  copyright: {
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '1.5rem 0',
    textAlign: 'center',
  },

  copyrightText: {
    margin: '0 0 1rem',
    fontSize: '0.875rem',
    color: '#6b7280',
    maxWidth: '100%',
  },

  footerSlnks: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    listStyle: 'none',
    gap: '15px',
    marginBottom: 0,
    paddingLeft: 0,
  },

  legalLink: {
    color: '#6b7280',
    textDecoration: 'none',
    fontSize: '0.875rem',
    transition: 'color 0.3s ease',
  },
};

// Add responsive styles and hover effects
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.innerText = `
    footer a:hover {
      color: #291e6c !important;
      transform: translateX(3px);
    }

    footer .footer_icon_list li a:hover span {
      transform: scale(1.1);
    }

    @media (max-width: 990px) {
      .footer_container {
        flex-direction: column-reverse !important;
      }

      .column_f, .column_f.fb_l {
        width: 100% !important;
        text-align: center !important;
        align-items: center !important;
        order: 1;
      }

      .column_f.fb_l {
        margin-top: 10px;
      }

      .footer_logo img {
        max-width: 70px !important;
      }

      footer .footer_icon_list {
        gap: 20px !important;
      }

      footer .link-list,
      footer .icon-list {
        align-items: center;
      }

      footer a {
        margin: 0 auto;
      }
    }
  `;
  document.head.appendChild(styleSheet);
}

export default Footer;
